/* globals angular, _ */

var ngModule = angular.module('trends');
var HVTS = ['sector', 'demographic', 'theme']; // HACK

ngModule.directive('marketApplication', ['Api', 'Restangular', '$q', 'Monitor', 'QuerySerializer',
    'HistoricContext', '$window', 'Usage',
    function (Api, Restangular, $q, Monitor, QuerySerializer, HistoricContext, $window, Usage) {
        return {
            restrict: 'A',
            scope: {trend: '@'},
            templateUrl: null,
            link: function (scope, element) {
                var loader = new Monitor();
                var serializer = new QuerySerializer({
                    h: {type: 'number'}, // HVT
                    m: {type: 'number', required: false} // Market application
                }, 'application');

                scope.initializing = true;
                /* Reinitalize the component to its default state. */
                var reset = function () {
                    scope.initializing = true;
                    scope.mapps = [];
                    scope.meta = null;
                    scope.wiif = null;
                    scope.position = 0;
                    scope.selections = {};

                    loader.reset();

                    // Load the HVTs for which this trend has WIIFs
                    Api.cachedRequest(Restangular.one('ma_meta', scope.trend),
                    'get', {hvt_type: ['demographic', 'sector']}).then(function (meta) {
                        scope.meta = meta;

                        // prioritize loading from the url over the temporary_context
                        var state = serializer.load() || loadStateFromContext();

                        // Attempt to load state or, failing that, pick a HVT to show
                        if (!loadState(state)) {
                            showDefaultHVT();
                        }
                    });
                };

                var loadStateFromContext = function() {
                    var state = false;
                    var context = HistoricContext.getValue('temporary_filter_context');
                    var groupPriorityOrder = ['sector', 'demographic'];

                    if (context) {
                        for (var n=0 ; n < groupPriorityOrder.length ; n++) {
                            var group = groupPriorityOrder[n];
                            if (scope.isGroupSelectable(group) && context[group]) {
                                state = {
                                    'h': findHVTForPk(context[group], group)
                                };
                                break;
                            }
                        }
                    }

                    return state;
                };

                /* Load from a saved state. Returns false on failure. */
                var loadState = function (state) {
                    if (state) {
                        var group = findGroupForHVT(state.h);
                        if (group && isHVTSelectable(group, state.h)) {
                            setSelectedGroup(group);

                            // if the hvt is located in other then use the 'other' representation
                            if(_.includes(scope.meta.other[group], state.h)) {
                                state.h = -1;
                            }

                            /* if there is no market application set, automatically load the first.*/
                            var promise = setSelectedHVT(state.h, !(state.m));
                            if (state.m) {
                                promise.then(function () { setSelectedMAByID(state.m); });
                            }
                            promise.then(function() {
                                scope.initializing = false;
                                saveToUrl();
                            });

                            return true;
                        }
                    }
                    return false;
                };

                /* Load the WIIF for a given HVT. */
                var loadWiif = function (hvt_id) {
                    var promise;
                    if (hvt_id === -1) {
                        // process the other case
                        promise = $q.when([{
                            'body': null, //body is in the template
                            'hvt': hvt_id,
                            'pk': -1,
                            'trend': scope.trend
                        }]);
                    }
                    else {
                        promise = Api.cachedRequest(Restangular.all('wiif'), 'getList',
                                {trend: scope.trend, hvt: hvt_id});
                    }

                    promise.then(function (wiif) {
                        scope.wiif = wiif[0];
                    });

                    return promise;
                };

                /* Load the market applications for a HVT and trend. */
                var loadApps = function (filters) {
                    // take all the relevant hvts for the other case, they are or'd on the backend
                    if (filters.hvt === -1) {
                        filters.hvt = scope.meta.other[scope.selections.group];
                    }

                    var promise = Api.cachedRequest(Restangular.all('mapp'), 'getList', filters);
                    promise.then(function(mapps) {
                        // Set the loaded MAs and attach each one's 'position'
                        for (var i = 0; i < mapps.length; i++) {
                            mapps[i].position = i;
                        }
                        scope.mapps = mapps;
                    });

                    return promise;
                };

                /* Return the report title and the section name if one can be found. */
                scope.getReportTitle = function (mapp) {
                    if (mapp.section_name) {
                        return mapp.report_title + ' - ' + mapp.section_name;
                    } else {
                        return mapp.report_title;
                    }
                };

                var findGroupForHVT = function (hvt_id) {
                    var group = null;

                    _.forEach(scope.meta.groups, function (hvts, key) {
                        if (_.find(hvts, 'hvt_id', hvt_id)) {
                            group = key;
                        }
                    });

                    if (!group) {
                        _.forEach(scope.meta.other, function (hvts, key) {
                            if (_.includes(hvts, hvt_id)) {
                                group = key;
                            }
                        });
                    }

                    return group;
                };

                /* needed to convert the pk stored in the historical context to hvt_id */
                var findHVTForPk = function(pk, group) {
                    var hvt = _.find(scope.meta.groups[group], 'pk', pk);
                    return hvt ? hvt.hvt_id : null;
                };

                /* Set the selected group. */
                var setSelectedGroup = function (group) {
                    scope.selections.group = group;
                };

                /* Set the selected MA by position. */
                var setSelectedMAByPos = function (pos) {
                    setSelectedMA(scope.mapps[pos]);
                };

                /* Set the selected MA by primary key. */
                var setSelectedMAByID = function (id) {
                    setSelectedMA(_.find(scope.mapps, 'pk', id));
                };

                /* Set the selected MA. */
                var setSelectedMA = function (ma) {
                    if (ma === undefined) {
                        return;
                    }
                    scope.selections.mapp = ma;
                    scope.position = ma.position;

                    element.find('.mapp .body').scrollTop(0);
                };

                /* Set the selected HVT (for the current group). */
                var setSelectedHVT = function (hvt_id, autoSelect) {
                    if (scope.isBusy()) {
                        return;
                    }
                    if (!scope.meta) {
                        throw new Error('meta is not loaded; cannot select HVT');
                    }

                    if (parseInt(scope.selections.hvt_pk, 10) !== hvt_id) {
                        if (hvt_id !== -1) {
                            scope.selections.hvt_pk = hvt_id;
                        }
                        else {
                            /* XXX: a blatant hack, can't figure out why the -1 is not picked up by
                               ng-model if it isn't a string */
                            scope.selections.hvt_pk = '-1';
                        }
                    }

                    var p1 = loadWiif(hvt_id);
                    var p2 = loadApps({trend: scope.trend, hvt: hvt_id});

                    return loader.watch($q.all([p1, p2]).then(function () {
                        scope.selections.hvt = getCurrentHvt(); // Store the HVT object
                        updateBackgroundImage();

                        if (autoSelect && scope.mapps && scope.mapps.length > 0) {
                            setSelectedMAByPos(0);
                        }
                    }));
                };

                /* Get the currently selected HVT. */
                var getCurrentHvt = function () {
                    if (scope.meta) {
                        // Annoyingly, bs-radio-group only works with numbers and strings
                        // so we can't use the HVT object as the model and we have this hacky thing
                        for (var name in scope.meta.groups) {
                            var group = scope.meta.groups[name];
                            for (var i = 0; i < group.length; i++) {
                                if (group[i].hvt_id === parseInt(scope.selections.hvt_pk, 10)) {
                                    return group[i];
                                }
                            }

                            // check the 'other' hvt_ids as well, if these are hit return -1
                            if (scope.meta.other[name]) {
                                var otherVals = scope.meta.other[name];
                                for (var i=0 ; i < otherVals.length ; i++) {
                                    if (otherVals[i] === parseInt(scope.selections.hvt_pk, 10)) {
                                        return otherVals[i];
                                    }
                                }
                            }
                        }
                    }

                    return null;
                };

                /* Update the current background image URL. */
                var updateBackgroundImage = function () {
                    var url = '';
                    scope.$watch(function(){
                        /* The document bit is an ugly IE8 work around. */
                        return $window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                    }, function(new_width){
                        if (new_width >  768) {
                            url = scope.selections.hvt ?
                                'url(' + scope.selections.hvt.image_url + ')' : '';
                        }
                        else {
                            url = scope.selections.hvt ?
                                'url(' + scope.selections.hvt.small_image_url + ')' : '';
                        }
                        element.removeAttr('style');
                        element.css('position', 'relative');
                        element.css('background-image', url);
                    });
                };

                /* Select and show a HVT for when the component first loads. */
                var showDefaultHVT = function () {
                    for (var i = 0; i < HVTS.length; i++) {
                        var group = HVTS[i];
                        if (scope.isGroupSelectable(group)) {
                            setSelectedGroup(group);
                            var promise = setSelectedHVT(scope.meta.groups[group][0].hvt_id, true);
                            promise.then(function() {
                                scope.initializing = false;
                            });

                            break;
                        }
                    }

                    // Else, we have no HVTs so show nothing
                    scope.selections.hvt = null;
                };

                var saveToUrl = function() {
                    var hval = parseInt(scope.selections.hvt_pk, 10);
                    if (hval === -1) {
                        if (scope.selections.mapp === undefined) {
                            return;
                        }
                        hval = scope.selections.mapp.hvts[0];
                    }

                    var serializeData = {
                        h:hval
                    };
                    if (scope.selections.mapp) {
                        serializeData.m = scope.selections.mapp.pk;
                    }

                    // gives the elements of the url to the sharing link
                    var urlStr = 'application=h:' + serializeData.h;
                    if (serializeData.m) {
                        urlStr += (',m:' + serializeData.m);
                    }

                    scope.url_components = urlStr;
                    serializer.save(serializeData);
                };

                /* Return true if a group can be selected. */
                scope.isGroupSelectable = function (group) {
                    if (!scope.meta) {
                        return false;
                    } else {
                        var group = scope.meta.groups[group];
                        return group && group.length > 0;
                    }
                };

                /* Return true if a HVT can be selected in `group`. */
                var isHVTSelectable = function (group, hvt_id) {
                    return scope.isGroupSelectable(group) &&
                            ( _.find(scope.meta.groups[group], 'hvt_id', hvt_id) !== undefined ||
                            _.includes(scope.meta.other[group], hvt_id));
                };

                /* Determine if a load is in progress. */
                scope.isBusy = function () {
                    return loader.isBusy();
                };

                /* Check if the report in direction `dir` can be moved to. */
                scope.canMove = function (dir) {
                    if (scope.mapps.length === 0/* || scope.isBusy() */) {
                        return false;
                    } else {
                        var to = scope.position + dir;
                        return to >= 0 && to < scope.mapps.length;
                    }
                };

                /* returns true if a load is occuring or before the initial load */
                scope.isResolved = function() {
                    return loader.resolved;
                };

                /* Move the selected report using a relative position. */
                scope.move = function (dir) {
                    setSelectedMAByPos(scope.position + dir);
                };

                /* Get the formatted application share URL (including host) */
                scope.getApplicationUrl = function (pk) {
                    return location.protocol + '//' + location.host + '/trends/#/trend/' + pk +
                        '?' + scope.url_components + '&to=applications';
                };

                scope.$watch('selections.mapp', function (after) {
                    if (after) {
                        scope.position = after.position; // Track our position in the list
                        saveToUrl();
                        Usage.log('viewdoc', { item_id: scope.selections.mapp.pk });
                    }
                });

                scope.$watch('selections.group', function (after) {
                    if (scope.meta) {
                        // Display the current group as options
                        scope.selections.hvts = scope.meta.groups[after];
                        if (!scope.initializing) {
                            scope.selections.hvt_pk = scope.selections.hvts[0].hvt_id;
                        }
                    }
                });

                // Gotcha: In the scope, hvt_pk is a string! Not sure how to get AngularStrap to use numbers...
                scope.$watch('selections.hvt_pk', function (after, before) {
                    if (after !== before && !scope.initializing) {
                        setSelectedHVT(parseInt(after, 10), true);
                        saveToUrl();
                    }
                });

                reset();
            }
        };
    }]);
